<Particles id="tsparticles" [options]="particlesOptions"></Particles>